import axiosClient from "../axiosClient";
import { ref, inject } from "vue";
import { useRouter } from "vue-router";

export default function useProductStatuses() {
  const productStatuses = ref({});
  const productStatus = ref({});
  const validationErrors = ref({});
  const isLoading = ref(false);

  const router = useRouter();
  const swal = inject("$swal");

  const getProductStatuses = async (
    page = 1,
    search_id = "",
    search_name_en = "",
    search_name_ar = "",
    search_global = "",
    order_column = "created_at",
    order_direction = "desc",
    per_page = 10
  ) => {
    axiosClient
      .get(
        "/product-statuses?" +
          "page=" +
          page +
          "&search_id=" +
          search_id +
          "&search_name_en=" +
          search_name_en +
          "&search_name_ar=" +
          search_name_ar +
          "&search_global=" +
          search_global +
          "&order_column=" +
          order_column +
          "&order_direction=" +
          order_direction +
          "&per_page=" +
          per_page
      )
      .then((response) => {
        productStatuses.value = response.data;
      })
      .catch((error) => {
        if (error.response?.data) {
          validationErrors.value = error.response.data.errors;

          swal({
            icon: "error",
            title: "Server error, please try again.",
          });
        }
      });
  };

  const getProductStatus = async (id) => {
    axiosClient.get("/product-statuses/" + id).then((response) => {
      productStatus.value = response.data.data;
    });
  };

  const storeProductStatus = async (productStatus) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    let serializedProductStatus = new FormData();
    for (let item in productStatus) {
      if (productStatus.hasOwnProperty(item)) {
        serializedProductStatus.append(item, productStatus[item]);
      }
    }

    axiosClient
      .post("/product-statuses", serializedProductStatus)
      .then((response) => {
        router.push({ name: "product-statuses.index" });
        swal({
          icon: "success",
          title: "product status saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const updateProductStatus = async (productStatus) => {
    if (isLoading.value) return;

    isLoading.value = true;
    validationErrors.value = {};

    axiosClient
      .put("/product-statuses/" + productStatus.id, productStatus)
      .then((response) => {
        router.push({ name: "product-statuses.index" });
        swal({
          icon: "success",
          title: "Product status saved successfully",
        });
      })
      .catch((error) => {
        if (error.response.data.errors) {
          validationErrors.value = error.response.data.errors;
        }
      })
      .finally(() => (isLoading.value = false));
  };

  const deleteProductStatus = async (id) => {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this action!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#ef4444",
      timer: 20000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient
          .delete("/product-statuses/" + id)
          .then((response) => {
            getProductStatuses();
            router.push({ name: "product-statuses.index" });
            swal({
              icon: "success",
              title: "Product status deleted successfully",
            });
          })
          .catch((error) => {
            swal({
              icon: "error",
              title: error,
            });
          });
      }
    });
  };

  return {
    productStatuses,
    productStatus,
    getProductStatuses,
    getProductStatus,
    storeProductStatus,
    validationErrors,
    isLoading,
    updateProductStatus,
    deleteProductStatus,
  };
}
